module.exports = __webpack_public_path__ + "media/images/flags/16/Lesotho-211114e895446d95e45aa3330aa57f9f.png";